'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Relude_IO = require("../Relude_IO.bs.js");

function toIO(promise) {
  return Relude_IO.async(function (onDone) {
              promise.then(function (v) {
                      return Promise.resolve(Curry._1(onDone, {
                                      TAG: /* Ok */0,
                                      _0: v
                                    }));
                    }).catch(function (e) {
                    return Promise.resolve(Curry._1(onDone, {
                                    TAG: /* Error */1,
                                    _0: e
                                  }));
                  });
              
            });
}

function toIOLazy(runPromise) {
  return Relude_IO.async(function (onDone) {
              var promise = Curry._1(runPromise, undefined);
              promise.then(function (v) {
                      return Promise.resolve(Curry._1(onDone, {
                                      TAG: /* Ok */0,
                                      _0: v
                                    }));
                    }).catch(function (e) {
                    return Promise.resolve(Curry._1(onDone, {
                                    TAG: /* Error */1,
                                    _0: e
                                  }));
                  });
              
            });
}

function fromIOWithResult(io) {
  return new Promise((function (resolve, param) {
                return Relude_IO.unsafeRunAsync((function (result) {
                              return resolve(result);
                            }), io);
              }));
}

function fromIO(io) {
  return new Promise((function (resolve, reject) {
                return Relude_IO.unsafeRunAsync((function (result) {
                              if (result.TAG === /* Ok */0) {
                                return resolve(result._0);
                              } else {
                                return reject(result._0);
                              }
                            }), io);
              }));
}

function fromIOExn(io) {
  return new Promise((function (resolve, reject) {
                return Relude_IO.unsafeRunAsync((function (result) {
                              if (result.TAG === /* Ok */0) {
                                return resolve(result._0);
                              } else {
                                return reject(result._0);
                              }
                            }), io);
              }));
}

function fromIOJsExn(io) {
  return new Promise((function (resolve, reject) {
                return Relude_IO.unsafeRunAsync((function (result) {
                              if (result.TAG === /* Ok */0) {
                                return resolve(result._0);
                              } else {
                                return reject(result._0);
                              }
                            }), io);
              }));
}

exports.toIO = toIO;
exports.toIOLazy = toIOLazy;
exports.fromIOWithResult = fromIOWithResult;
exports.fromIO = fromIO;
exports.fromIOExn = fromIOExn;
exports.fromIOJsExn = fromIOJsExn;
/* Relude_IO Not a pure module */
